export class Language {
   public Key = 'pt';
   public Name = 'Português';
   public Country = 'Brazil';
   public FlagIcon = 'br';
   public LocaleCode = 'pt-BR';
}
